import { render, staticRenderFns } from "./TransactionToCollecting.vue?vue&type=template&id=77e3776c"
import script from "./TransactionToCollecting.vue?vue&type=script&lang=js"
export * from "./TransactionToCollecting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports